import React from 'react';
import WatercraftWordmark from './WatercraftWordmark';

interface WatercraftAuthLayoutProps {
  children: React.ReactNode;
  heading?: string;
  subheading?: string;
}

export default function WatercraftAuthLayout({
  children,
  heading,
  subheading,
}: WatercraftAuthLayoutProps): React.JSX.Element {
  return (
    <main className='flex min-h-screen w-full flex-col items-center justify-center gap-8 bg-gradient-to-b from-watercraft-bg to-watercraft-surface p-6 text-watercraft-text-primary'>
      <WatercraftWordmark className='h-9 w-auto text-watercraft-text-primary' />
      <section className='w-full max-w-sm rounded-xl border border-watercraft-border bg-watercraft-surface p-6'>
        {heading && (
          <h1 className='text-2xl font-bold text-watercraft-text-primary'>
            {heading}
          </h1>
        )}
        {subheading && (
          <p className='mt-1 text-sm text-watercraft-text-secondary'>
            {subheading}
          </p>
        )}
        <div className={heading || subheading ? 'mt-6' : ''}>{children}</div>
      </section>
    </main>
  );
}
